function fixCSVRowAfterMapping(currentCSVRow, rowMappingObjectForTargetMapping) {

  if (rowMappingObjectForTargetMapping['EK'] != null) {
    var ek = currentCSVRow[rowMappingObjectForTargetMapping['EK']];
    if (ek != null) {
      currentCSVRow[rowMappingObjectForTargetMapping['EK']] = parsePotentiallyGroupedFloat(ek);
    }
  }
  if (rowMappingObjectForTargetMapping['VK'] != null) {
    var vk = currentCSVRow[rowMappingObjectForTargetMapping['VK']];
    if (vk != null) {
      currentCSVRow[rowMappingObjectForTargetMapping['VK']] = parsePotentiallyGroupedFloat(vk);
    }
  }
  return currentCSVRow;
}
/**
 * used for ek parsing during import
 * transforms "1.000,00 €" and "1000€" and "1.000" to 1000
 *  "1.456,78" or "1456.78" or "1.456,78 €"  to 1456.78
 */
function parsePotentiallyGroupedFloat(stringValue) {
  // if it's already a number, return it
  if (!isNaN(stringValue)) {
    return parseFloat(stringValue)
  }
  if (stringValue == null || stringValue == undefined || typeof stringValue !== 'string') {
    return 0;
  }
  
  // remove currency symbol:
  stringValue = stringValue.replace("€", "");
  stringValue = stringValue.trim();
  //  when comma,cut string with 2 digits after dot
  let parts = stringValue.split(',');
  if (parts.length > 1) {
    parts[1] = parts[1].substring(0, 2);
    stringValue = parts.join(',');
  }
  // remove all non-numeric characters:
  var result = stringValue.replace(/[^0-9]/g, '');

  if (/[,.]\d{1}$/.test(stringValue)) {
    // then add a dot as decimal separator
    result = result.replace(/(\d{1})$/, '.$1');
  }
  // check if we have a comma or dot as decimal separator
  if (/[,.]\d{2}$/.test(stringValue)) {
    // then add a dot as decimal separator
    result = result.replace(/(\d{2})$/, '.$1');
  }
  return parseFloat(result);
}


export { fixCSVRowAfterMapping };